import React from 'react'
import { connect } from 'react-redux'

import { SelectRow } from '../../../../components'
import { gettext } from '@bikemap/js/services'
import { toggleMapView } from '../../actions'

const t = {
    LIST: gettext('List view'),
    MAP: gettext('Map view'),
}

/** @param {import("../../store").SearchState} state */
const mapStateToProps = ({ isMapView }) => ({
    options: [
        { value: 0, name: <i className="i-view-list i-sm" title={t.LIST} /> },
        { value: 1, name: <i className="i-map i-sm" title={t.MAP} /> },
    ],
    value: isMapView ? 1 : 0,
})

const mapDispatchToProps = dispatch => ({
    onChange: value => dispatch(toggleMapView(!!value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(SelectRow)
